export function iniciarContadorDesdeHTML() {
    const elSec = document.getElementById('secPerKg');
    const elDay = document.getElementById('dayPerKg');
    const elTotal = document.getElementById('totalToday');

    if (!elSec || !elDay || !elTotal) return;

    const capturaSegundoEnKilos = parseFloat(elSec.textContent);
    const capturaDiaEnKilos = parseFloat(elDay.textContent);
    const totalHoyEnKilos = parseFloat(elTotal.textContent);

    const totalMedianoche = totalHoyEnKilos - capturaDiaEnKilos;

    function segundosDesdeMedianoche() {
        const ahora = new Date();
        return ahora.getHours() * 3600 + ahora.getMinutes() * 60 + ahora.getSeconds();
    }

    function formatearNumero(numero) {
        return numero.toLocaleString('es-CL', { maximumFractionDigits: 0 });
    }

    function calcularTotalActual() {
        const segundosPasados = segundosDesdeMedianoche();
        return totalMedianoche + (capturaSegundoEnKilos * segundosPasados);
    }

    let totalActual = calcularTotalActual();
    let displayValue = totalActual;

    // Función de animación suave
    function animarContador(targetValue) {
        const duration = 900; // milisegundos (ligeramente menos que 1s para llegar a tiempo)
        const startValue = displayValue;
        const startTime = performance.now();

        function animate(now) {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            displayValue = startValue + (targetValue - startValue) * progress;
            elTotal.textContent = formatearNumero(displayValue);

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                displayValue = targetValue;
            }
        }

        requestAnimationFrame(animate);
    }

    elTotal.textContent = formatearNumero(totalActual);

    setInterval(() => {
        totalActual += capturaSegundoEnKilos;
        animarContador(totalActual);
    }, 1000);
}

export function iniciarContadorDesdeFechaBase() {
    const elSec = document.getElementById('secPerKg');
    const elTotal = document.getElementById('totalToday');
    const elBase = document.getElementById('totalTodayBase');

    if (!elSec || !elTotal || !elBase) return;

    const capturaSegundoEnKilos = parseFloat(elSec.value);
    const valorBase = parseFloat(elBase.value);

    // FECHA BASE: 1 de mayo a las 00:00 del año actual
    const fechaBase = new Date(new Date().getFullYear(), 4, 1, 0, 0, 0);

    function segundosDesdeFechaBase() {
        const ahora = new Date();
        return Math.floor((ahora - fechaBase) / 1000);
    }

    function formatearNumero(numero)
    {
        return numero.toLocaleString('es-CL', { maximumFractionDigits: 0 });
    }

    function calcularTotalActual() {
        const segundosPasados = segundosDesdeFechaBase();
        return valorBase + (capturaSegundoEnKilos * segundosPasados);
    }

    let totalActual = calcularTotalActual();
    let displayValue = totalActual;

    function animarContador(targetValue) {
        const duration = 900;
        const startValue = displayValue;
        const startTime = performance.now();

        function animate(now) {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            displayValue = startValue + (targetValue - startValue) * progress;
            elTotal.textContent = formatearNumero(displayValue);

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                displayValue = targetValue;
            }
        }

        requestAnimationFrame(animate);
    }

    elTotal.textContent = formatearNumero(totalActual);

    setInterval(() => {
        totalActual += capturaSegundoEnKilos;
        animarContador(totalActual);
    }, 1000);
}

export function iniciarContadorEvitadoDesdeFechaBase() {
    const elSecInput = document.getElementById('evitadoPorSegundo');
    const elTotal = document.getElementById('evitadoTotal');
    const elBase = document.getElementById('evitadoTotalBase');

    if (!elSecInput || !elTotal || !elBase) return;

    const evitadoPorSegundo = parseFloat(elSecInput.value);
    const valorBase = parseFloat(elBase.value);

    // FECHA BASE: 1 de mayo
    const fechaBase = new Date(new Date().getFullYear(), 4, 1, 0, 0, 0);

    function segundosDesdeFechaBase() {
        const ahora = new Date();
        return Math.floor((ahora - fechaBase) / 1000);
    }

    function formatearNumero(numero) {
        return numero.toLocaleString('es-CL', { maximumFractionDigits: 0 });
    }

    function calcularTotalActual() {
        const segundosPasados = segundosDesdeFechaBase();
        return valorBase + (evitadoPorSegundo * segundosPasados);
    }

    let totalActual = calcularTotalActual();
    let displayValue = totalActual;

    function animarContador(targetValue) {
        const duration = 900;
        const startValue = displayValue;
        const startTime = performance.now();

        function animate(now) {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            displayValue = startValue + (targetValue - startValue) * progress;
            elTotal.textContent = formatearNumero(displayValue);

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                displayValue = targetValue;
            }
        }

        requestAnimationFrame(animate);
    }

    elTotal.textContent = formatearNumero(totalActual);

    setInterval(() => {
        totalActual += evitadoPorSegundo;
        animarContador(totalActual);
    }, 1000);
}

export function iniciarContadorCO2() {
    // ⚠️ Valores estáticos. Si cambian en el backend, deben actualizarse manualmente aquí.
    const capturaPorSegundo = 0.701;          // kg por segundo
    const valorBase = 185115000;              // total histórico base desde el 01/mayo

    // Elementos donde se mostrará el contador
    const elTotal = document.getElementById('totalToday');
    const elHeader = document.getElementById('co2TotalHeader');

    if (!elTotal && !elHeader) return; // Nada que mostrar

    // Base: 01/mayo/año_actual a las 00:00:00
    const fechaBase = new Date(new Date().getFullYear(), 4, 1, 0, 0, 0);

    function segundosDesdeFechaBase() {
        const ahora = new Date();
        return Math.floor((ahora - fechaBase) / 1000);
    }

    function formatearNumero(numero) {
        return numero.toLocaleString('es-CL', { maximumFractionDigits: 0 });
    }

    function calcularTotalActual() {
        const segundosPasados = segundosDesdeFechaBase();
        return valorBase + (capturaPorSegundo * segundosPasados);
    }

    let totalActual = calcularTotalActual();
    let displayValue = totalActual;

    function actualizarElementosUI(valorFormateado) {
        if (elTotal) elTotal.textContent = valorFormateado;
        if (elHeader) elHeader.textContent = valorFormateado;
    }

    function animarContador(targetValue) {
        const duration = 900;
        const startValue = displayValue;
        const startTime = performance.now();

        function animate(now) {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            displayValue = startValue + (targetValue - startValue) * progress;
            const formatted = formatearNumero(displayValue);
            actualizarElementosUI(formatted);

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                displayValue = targetValue;
            }
        }

        requestAnimationFrame(animate);
    }

    actualizarElementosUI(formatearNumero(totalActual));

    setInterval(() => {
        totalActual += capturaPorSegundo;
        animarContador(totalActual);
    }, 1000);
}


